import React, { useContext, useEffect, useRef } from "react";
import { useState, createContext } from "react";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';

const LoginNew = () => {
  const { apiURL, handleUpdateLogin } = useContext(ConfigContext);
  // const [username, setUsername] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isEmailSend, setIsEmailSend] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingSendOtp, setLoadingSendOtp] = useState(false);
  const [loadingResendOtp, setLoadingResendOtp] = useState(false);
  const [loginType, setLoginType] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(new Array(5).fill(""));

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
    setErrors({ ...errors, [event.target.name]: "" });
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  useEffect(() => {
    setErrorMessage("");
  }, [username, password]);
  useEffect(() => {
    console.log("otp",otp);
    // if(otp?.length===5){
    //   if(isEmailSend){
    //     handleSubmit();
    //   }
    // }
  }, [otp]);

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };

//   const handleUsernameChange = (event) => {
//     setUsername(event.target.value);
//   };
  const handleEmailChange = (event) => {
    setUsername(event.target.value);
    setErrors({ ...errors, [event.target.name]: "" });
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleRememberMeChange = (event) => {
    setRememberMe(event.target.checked);
  };

const getLoginSettings = async (event) => {
    event.preventDefault();

    const errors = validateForm(0);
    console.log("getLoginSettings errors", errors);
    if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
    }
    setLoadingSendOtp(true);
    axios.post(`${apiURL}User/VerifyLoginType`, {login_id: username})
    .then((response)=>{
        const data = response.data;
        console.log("response => VerifyLoginType",data);
        if(data.success){
          if(data?.login_type=="2"){
            setLoadingSendOtp(true);
            handleSendOtp(event);
            // setLoginType(`${data?.login_type}`);
          }
          else{
            setLoginType(data?.login_type || "1");
             setLoadingSendOtp(false);
          }
            
        }
        else{
            Swal.fire({
                title: `<strong>${data.success ? 'Success' : 'Failed'}</strong>`,
                text: data.message,
                icon: data.success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
            setLoadingSendOtp(false);
        }
       
    })
    .catch((error)=>{
        console.log("Error during LoginWithOtp:====>", error);
        Swal.fire({
            title: `<strong>Failed</strong>`,
            text: "Opps...!Something went wrong. Please try again later.",
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
        })
        setLoadingSendOtp(false);
        // setErrorMessage("Something went wrong. Please try again later.");
    })
};
const handleSendOtp = async (event) => {
    event.preventDefault();

    const errors = validateForm(0);
    console.log("LoginWithOtp errors", errors);
    if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
    }
    
    axios.post(`${apiURL}User/LoginWithOtp`, {login_id: username})
    .then((response)=>{
        const data = response.data;
        console.log("response => LoginWithOtp",data);
        if(data.success){
            setIsEmailSend(data.message);
            setLoginType("2");
        }
        else{
            Swal.fire({
                title: `<strong>${data.success ? 'Success' : 'Failed'}</strong>`,
                text: data.message,
                icon: data.success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            })
        }
        setLoadingSendOtp(false);
        setLoadingResendOtp(false);
    })
    .catch((error)=>{
        console.log("Error during LoginWithOtp:====>", error);
        Swal.fire({
            title: `<strong>Failed</strong>`,
            text: "Opps...!Something went wrong. Please try again later.",
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
        })
        setLoadingSendOtp(false);
        setLoadingResendOtp(false);
        // setErrorMessage("Something went wrong. Please try again later.");
    })
};

const validateForm = (from=0) => {
    let errors = {}
    console.log("from",from);
    if (!username) {
        errors.username = "Email or Username is required!"
        return errors
    }
    console.log("from===2 && !otp || (Array.isArray(otp) && otp?.length===0)",from==="2" && !otp || (Array.isArray(otp) && otp?.length===0))
    if( from==="2" && (!otp || (Array.isArray(otp) && otp?.length===0))){
        errors.otp = "OTP is required!"
        return errors
    }
    return errors
}
const handlePasswordSubmit = async (event) => {
  event.preventDefault();
  setLoadingSendOtp(true);
  

  try {
    const response = await axios.post(`${apiURL}User/Login?login_id=${username}&login_password=${password}`, )    

    const data = response.data;
    // console.log("Login",data);
    if (data.success) {
      handleUpdateLogin(response.data.data);
      setUsername("");
      setPassword("");
      console.log("data?.induction_status",data?.data?.induction_status)
      if(data?.data?.induction_status==="0"){
        localStorage.setItem("induction_status",data?.data?.induction_status);
      }
      else{
        localStorage.removeItem("induction_status");
      }
      const now = Date.now();
      localStorage.setItem('lastActive_emp', now);
      sessionStorage.setItem('session_active_emp', 'true');
      localStorage.removeItem("reset_emp");
      window.location.href = '/';
      // navigate('/');
      setLoadingSendOtp(false);
    } 
    else {
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: `${ data?.message || "Invalid username or password"}`,
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick: false,
    })
      // setErrorMessage();
      setLoadingSendOtp(false);
    }
  } catch (error) {
    console.log("Error during login:====>", error);
    // setErrorMessage("Something went wrong. Please try again later.");
    Swal.fire({
      title: `<strong>Failed</strong>`,
      text: "Opps...!Something went wrong. Please try again later.",
      icon: 'error',
      showConfirmButton: true,
      allowOutsideClick: false,
  })
    setLoadingSendOtp(false);
    
  }
};
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("enter submit");
    const errors = validateForm("2");
    console.log("ValidateLoginOTP", errors);
    if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
    }
    setLoadingSendOtp(true);
    const otpValue= parseInt(otp?.map((val)=> val).join(""));
    console.log("otpValue",otpValue, typeof otpValue);
    axios.post(`${apiURL}User/ValidateLoginOTP`, {login_id: username, otp: otpValue})
    .then((response)=>{
        const data = response.data;
        console.log("response => ValidateLoginOTP",data);
        if(data.success){
            // setIsEmailSend(false);
            handleUpdateLogin(response.data.data);
            setUsername("");
            console.log("data?.induction_status",data?.data?.induction_status)
            if(data?.data?.induction_status==="0"){
              localStorage.setItem("induction_status",data?.data?.induction_status);
            }
            else{
              localStorage.removeItem("induction_status");
            }
            const now = Date.now();
            localStorage.setItem('lastActive_emp', now);
            sessionStorage.setItem('session_active_emp', 'true');
            localStorage.removeItem("reset_emp");
            window.location.href = '/';
        }
        else{
            Swal.fire({
                title: `<strong>${data.success ? 'Success' : 'Failed'}</strong>`,
                text: data.message,
                icon: data.success ? 'success' : 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
            setLoadingSendOtp(false);
        }
        
    })
    .catch((error)=>{
        console.log("Error during LoginWithOtp:====>", error);
        Swal.fire({
            title: `<strong>Failed</strong>`,
            text: "Opps...!Something went wrong. Please try again later.",
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
        })
        setLoadingSendOtp(false);
        // setErrorMessage("Something went wrong. Please try again later.");
    })
  };



  const handleClear=()=>{
    // setUsername('');
    setLoginType(false);
    setIsEmailSend(false);
    setLoadingSendOtp(false);
    setOtp(['','','','','',]);
    setErrors({});
  }

  return (
    <>
      <div className="auth-page-wrapper ">

        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay "></div>

          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>
      </div>

      <div className="auth-page-content">
        <div style={{ height: "89vh"}} className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mb-4 text-white">
                <div className="d-inline-block auth-logo">
                  <a href="index.html">

                    <img src="" alt="" height="80" />
                  </a>
                </div>
                <p className="mt-3 fs-15 fw-bolder">Employee Panel</p>
              </div>
            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-3">
                <div className="card-body rounded-3 position-absolute w-100 bg-white position-relative z-1  p-4">
                  {(loginType=="1" || loginType=="2") && (
                    <div onClick={(e)=>{
                      if(!loadingSendOtp && !loadingResendOtp){
                        handleClear(e);
                      }}} className="back-icon text-primary">
                      <i className="ri-arrow-left-line leftIconBack" />
                    </div>
                  )}
                  
                  <div className="mb-4">
                      <div className=" avatar-sm mx-auto">
                      <div className="avatar-title bg-light text-primary display-5 rounded-circle shadow">
                          <i className={`${ loginType=="2" ? "ri-mail-line" : loginType=="1" ? "ri-lock-password-line" : "bx bx-user-pin"}`} />
                      </div>
                      </div>
                  </div>
                  <div className="p-2 mt-4">
                      <div className={`text-muted text-center ${loginType=="2" ? "mb-4" : "mb-0"}  mx-lg-3`}>
                      { !loginType && (
                          <h4 className="text-primary">Welcome Back !</h4>
                      )}
                      { loginType=="2" && (
                      <h4>Verify Your Email</h4>)}
                      { loginType=="1" && (
                      <h4>Verify Your Password</h4>)}
                      { !loginType && (
                          <p>Please enter your username to login</p>)}
                      { loginType=="2" && ( 
                          <p>Please enter the 5 digit <span className="fw-semibold">{isEmailSend}</span></p>)}
                      { loginType=="1" && ( 
                          <p>Please enter your password</p>)}
                      </div>
                      <form onSubmit={(e)=>{
                              if(loginType=="1" && !loadingSendOtp){
                                  handlePasswordSubmit(e);
                              }
                              else if( loginType=="2" && !loadingSendOtp ){
                                handleSubmit(e);
                              }
                              else if(!loginType && !loadingSendOtp){
                                  // handleSendOtp(e);
                                  getLoginSettings(e);
                              }
                              }}>
                      {!loginType || loginType=="1" ? (
                          <div>
                              <div className="mb-3">
                                  <label htmlFor="username" className="form-label">
                                  Username
                                  </label>
                                  <input
                                  type="text"
                                  className="form-control position-relative z-1"
                                  id="username"
                                  name="username"
                                  placeholder="Enter Username"
                                  value={username}
                                  onChange={handleEmailChange}
                                  disabled={loginType=="1"}
                                  // autoComplete="off"
                                  />
                                  <div className=" text-danger">{errors?.username ? errors?.username : null}</div>
                              </div>
                              {loginType=="1" && (
                                <div className="mb-3">
                                  <div className="float-end">
                                    <NavLink
                                      to={`/ForgotPassword?user=${username}`}
                                      className="text-muted"
                                    >
                                      Forgot password?
                                    </NavLink>
                                  </div>
                                  <label className="form-label" htmlFor="password-input">
                                    Password
                                  </label>
          
                                  <div className="position-relative auth-pass-inputgroup mb-3">
                                    <input
                                      type={`${showPassword ? 'text' : 'password'}`}
                                      className="form-control pe-5 password-input"
                                      placeholder="Enter password"
                                      id="password-input"
                                      value={password}
                                      onChange={handlePasswordChange}
                                      autoComplete="off"
                                    />
                                    <button
                                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                                      type="button"
                                      id="password-addon"
                                      onClick={togglePassword}
                                    >
                                      <i className={`${showPassword ? 'las la-eye align-middle' : 'las la-eye-slash align-middle'}`}></i>
                                    </button>
                                  </div>
                                </div>
                              )}
                          </div>
                      ) :  (
                        <div className="d-flex justify-content-around">
                            {otp.map((digit, index) => (
                            <div className="col-2" key={index}>
                                <div className="mb-3">
                                    <input
                                    type="text"
                                    className="form-control form-control-lg bg-light border-light text-center"
                                    maxLength={1}
                                    value={digit}
                                    id="otp"
                                    name="otp"
                                    onChange={(e) => handleChange(index, e)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    />
                                </div>
                            </div>
                            ))}
                            <div className=" text-danger">{errors?.otp ? errors?.otp : null}</div>
                        </div>
                        )}
                      
                        <div className="mt-3">
                          <button type="submit" className="btn btn-success w-100">{ !loadingSendOtp ? loginType=="1" ? "Login" : loginType=="2" ? "Confirm" : "Next" :
                              <span className="d-flex align-items-center justify-content-center">
                              <span class={`spinner-border flex-shrink-0 midLoader`} role="status">
                                <span class="visually-hidden">loading...</span>
                              </span>
                            </span>
                            }</button>
                        </div>
                      </form>
                      {loginType=="2" && (
                          <>
                              {/* <div className="mt-4 text-center">
                                  <p className="mb-0">
                                  Want to go back ?
                                  <span onClick={(e)=>{
                                    if(!loadingSendOtp && !loadingResendOtp){
                                      handleClear(e);
                                  }
                                  }} className={`fw-semibold text-primary text-decoration-underline ${!loadingSendOtp && "cursorPointer"}`}>
                                      Back
                                  </span>
                                  </p>
                              </div> */}
                              <div className="text-center">
                                  <p className="mb-0 d-flex align-items-center justify-content-center gap-1">
                                      Didn't received a OTP?
                                  <span onClick={(e)=>{ 
                                      if(!loadingSendOtp && !loadingResendOtp){
                                        setLoadingResendOtp(true);
                                        handleSendOtp(e); 
                                      }
                                      }} className={`fw-semibold text-primary text-decoration-underline ${!loadingSendOtp && "cursorPointer"}`}>
                                      {!loadingResendOtp ?
                                      "Resend" : (
                                        <span className="d-flex align-items-center justify-content-center">
                                        <span class={`spinner-border flex-shrink-0 smallLoader`} role="status">
                                          <span class="visually-hidden">loading...</span>
                                        </span>
                                      </span>
                                      )}
                                  </span>
                                  </p>
                              </div>
                          </>
                      ) }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <footer style={{padding: "20px calc(1.5rem* .5)"}} className="">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">
                  &copy;
                  Employee Panel. Developed by
                  TalentCo IT
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
    </>
  );
};

export default withRouter(LoginNew);
